export default {
  path: 'trip-configuration/:id',
  name: 'TripConfigurationDetails',
  component: () => import(/* webpackChunkName: "administration" */ '../views/TripConfigurationDetails.vue')
}
